import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  OrganizationMipsSubmissionStatus,
  BlockOrganizationRequest,
  BulkBlockOrganizationsRequest,
} from '@models/mips-submission-block.model';

export const MipsSubmissionBlockActions = createActionGroup({
  source: 'Mips Submission Block',
  events: {
    'Load Organization Statuses': emptyProps(),
    'Load Organization Statuses Success': props<{ statuses: OrganizationMipsSubmissionStatus[] }>(),
    'Load Organization Statuses Failure': props<{ error: string }>(),

    'Block Organization': props<{ request: BlockOrganizationRequest }>(),
    'Block Organization Success': props<{ status: OrganizationMipsSubmissionStatus }>(),
    'Block Organization Failure': props<{ error: string }>(),

    'Unblock Organization': props<{ organizationId: number }>(),
    'Unblock Organization Success': props<{ organizationId: number }>(),
    'Unblock Organization Failure': props<{ error: string }>(),

    'Bulk Block Organizations': props<{ request: BulkBlockOrganizationsRequest }>(),
    'Bulk Block Organizations Success': props<{ statuses: OrganizationMipsSubmissionStatus[] }>(),
    'Bulk Block Organizations Failure': props<{ error: string }>(),
  },
});
